import { createApi } from "@reduxjs/toolkit/query/react";
import { ApiEndpoints, baseQueryWithAuth } from "../../../core";

export const groupApi = createApi({
  reducerPath: "groupApi",
  baseQuery: baseQueryWithAuth,
  tagTypes: ["Groups"],

  endpoints: (builder) => ({
    getGroups: builder.query<any, string>({
      query: (categoryId) => ({
        url: `${ApiEndpoints.getAllGroups}/${categoryId}`,
        method: "GET",
      }),
      providesTags: (result) =>
        result
          ? [
              ...(result.results || []).map(({ _id }: any) => ({
                type: "Groups" as const,
                id: _id,
              })),
              { type: "Groups", id: "LIST" },
            ]
          : [{ type: "Groups", id: "LIST" }],
    }),
  }),
});

export const { useGetGroupsQuery } = groupApi;
